module.exports = __webpack_public_path__ + "static/ho-9c5f12ad0d1434bf7529f79bf71abe04.png";